/** 設定識別ID */
export const SCREEN_ACTION_SETTING_ID = 'biz-menu-page-sas';

/**
 * 業務メニュー(整備)(鈑金)(車販) 画面動作設定インターフェース定義
 */
export interface IBizMenuPageScreenActionSetting {
  sf: ISfBizMenuPageScreenActionSetting;
  repair: IRepairBizMenuPageScreenActionSetting;
  carSales: ICarsalesBizMenuPageScreenActionSetting;
  /** 受付起動時の遷移先設定 */
  reception: IReceptionBizMenuPageScreenActionSetting;
}

/**
 * 受付起動時の画面動作設定インターフェース定義
 */
export interface IReceptionBizMenuPageScreenActionSetting {
  /** 整備の受付起動時遷移先 */
  sf: string;
  /** 鈑金の受付起動時遷移先 */
  repair: string;
}

/**
 * 業務メニュー(整備)画面動作設定インターフェース定義
 */
export interface ISfBizMenuPageScreenActionSetting {
  /** 見積り区分 */
  firstSlipNavigationDiv: string;
  /** 作業指示/注文区分 */
  secondSlipNavigationDiv: string;
  /** 納品書区分 */
  thirdSlipNavigationDiv: string;
}

/**
 * 業務メニュー(鈑金)画面動作設定インターフェース定義
 */
export interface IRepairBizMenuPageScreenActionSetting {
  /** 見積り区分 */
  firstSlipNavigationDiv: string;
  /** 作業指示/注文区分 */
  secondSlipNavigationDiv: string;
  /** 納品書区分 */
  thirdSlipNavigationDiv: string;
}

/**
 * 業務メニュー(車販) 画面動作設定インターフェース定義
 */
export interface ICarsalesBizMenuPageScreenActionSetting {
  /** 見積り区分 */
  firstSlipNavigationDiv: string;
  /** 作業指示/注文区分 */
  secondSlipNavigationDiv: string;
}

/**
 * プロダクト毎の伝票種別画面の表示設定を定義するインターフェース
 * 生成された設定オブジェクトは、画面の初期表示や動的なコンテンツ生成に利用される
 */
export interface DisplayConfig {
  /** プロダクト名 */
  productCodeName: string;
  /** バインド先の画面や設定を特定するためのパス (例: 'sf') */
  settingPath: string;
  /** 一つ目の伝票種別のナビゲーションアイテムリスト */
  firstNavItems: any[];
  /** 二つ目の伝票種別のナビゲーションアイテムリスト */
  secondNavItems: any[];
  /** 三つ目伝票種別のナビゲーションアイテムリスト。車販、存在しない場合は undefined となる */
  thirdNavItems?: any[];
  /** 一つ目の伝票種別の表示名 */
  firstName: string;
  /** 二つ目の伝票種別の表示名 */
  secondName: string;
  /** 三つ目の伝票種別の表示名。車販、存在しない場合は undefined となる */
  thirdName?: string;
  /** 受付起動時のナビゲーションアイテムリスト。対象外の場合は undefined となる */
  receptionNavItems?: any[];
  /** 受付設定の表示名。対象外の場合は undefined となる */
  receptionName?: string;
}

/**
 * 伝票種別に応じた、ナビゲーション設定オブジェクト内のプロパティ名
 */
export const SLIP_NAVIGATION_PROPERTY = {
  /** 見積伝票用の設定プロパティ名 */
  ESTIMATES_SLIP: 'firstSlipNavigationDiv',
  /** 指示/注文伝票用の設定プロパティ名 */
  INSTRUCTIONS_SLIP: 'secondSlipNavigationDiv',
  /** 売上伝票用の設定プロパティ名 */
  SALES_SLIP: 'thirdSlipNavigationDiv',
};

/**
 * 受付起動時の遷移先区分
 */
export const ReceptionNavigationDiv = {
  /** 顧客・車両検索 */
  CustomerVehicleSearch: '0',
  /** 受付一覧 */
  ReceptionList: '1',
};

/**
 * 受付起動時の遷移先区分の配列情報
 */
export const ReceptionNavigationDivArray: Array<{value: string, text: string}> = [
  { value: ReceptionNavigationDiv.CustomerVehicleSearch, text: '顧客・車両検索' },
  { value: ReceptionNavigationDiv.ReceptionList, text: '受付一覧' },
];

/**
 * 見積り導線区分のenum定義(整備)
 */
export const SfEstimatesSlipDiv = {
  /** 見積書の一覧 */
  SfSalesSlipSearch: '0',
  /** 願客・車両検索 */
  VehicleSearch: '1',
};

/**
 * 見積り導線区分の配列情報(整備)
 */
export const SfEstimatesSlipDivArray: Array<{value: string, text: string}> = [
  { value: '0', text: '見積書の一覧' },
  { value: '1', text: '顧客・車両検索' },
];

/**
 * 作業指示導線区分のenum定義(整備)
 */
export const SfInstructionsSlipDiv = {
  /** 指示書の一覧 */
  SfSalesSlipSearch: '0',
  /** 願客・車両検索 */
  VehicleSearch: '1',
};

/**
 * 作業指示導線区分の配列情報(整備)
 */
export const SfInstructionsSlipDivArray: Array<{value: string, text: string}> = [
  { value: '0', text: '指示書の一覧' },
  { value: '1', text: '顧客・車両検索' },
];

/**
 * 納品書導線区分のenum定義(整備)
 */
export const SfSalesSlipDiv = {
  /** 納品書の一覧 */
  SfSalesSlipSearch: '0',
  /** 願客・車両検索 */
  VehicleSearch: '1',
};

/**
 * 納品書導線区分の配列情報(整備)
 */
export const SfSalesSlipDivArray: Array<{value: string, text: string}> = [
  { value: '0', text: '納品書の一覧' },
  { value: '1', text: '顧客・車両検索' },
];

/**
 * 見積り導線区分のenum定義(鈑金)
 */
export const RepairEstimatesSlipDiv = {
  /** 見積書の一覧 */
  RepairSalesSlipSearch: '0',
  /** 見積条件画面 */
  SalesSlipEntryCondition: '1',
};

/**
 * 見積り導線区分の配列情報(鈑金)
 */
export const RepairEstimatesSlipDivArray: Array<{value: string, text: string}> = [
  { value: '0', text: '見積書の一覧' },
  { value: '1', text: '見積書' },
];

/**
 * 作業指示導線区分のenum定義(鈑金)
 */
export const RepairInstructionsSlipDiv = {
  /** 指示書の一覧 */
  RepairSalesSlipSearch: '0',
  /** 見積条件画面 */
  SalesSlipEntryCondition: '1',
};

/**
 * 作業指示導線区分の配列情報(鈑金)
 */
export const RepairInstructionsSlipDivArray: Array<{value: string, text: string}> = [
  { value: '0', text: '指示書の一覧' },
  { value: '1', text: '指示書' },
];

/**
 * 納品書導線区分のenum定義(鈑金)
 */
export const RepairSalesSlipDiv = {
  /** 納品書の一覧 */
  RepairSalesSlipSearch: '0',
  /** 見積条件画面 */
  SalesSlipEntryCondition: '1',
};

/**
 * 納品書導線区分の配列情報(鈑金)
 */
export const RepairSalesSlipDivArray: Array<{value: string, text: string}> = [
  { value: '0', text: '納品書の一覧' },
  { value: '1', text: '納品書' },
];

/**
 * 見積り導線区分のenum定義(車販)
 */
export const CarSalesEstimatesSlipDiv = {
  /** 見積書の一覧 */
  CarSalesSlipSearch: '0',
  /** 見積書 */
  EstimatesSlip: '1',
};

/**
 * 見積り導線区分の配列情報(車販)
 */
export const CarSalesEstimatesSlipDivArray: Array<{value: string, text: string}> = [
  { value: '0', text: '見積書の一覧' },
  { value: '1', text: '見積書' },
];

/**
 * 注文書導線区分のenum定義(車販)
 */
export const CarSalesSlipOrderDiv = {
  /** 注文書の一覧 */
  CarSalesSlipSearch: '0',
  /** 願客・車両検索 */
  VehicleSearch: '1',
};

/**
 * 注文書導線区分の配列情報(車販)
 */
export const CarSalesSlipOrderDivArray: Array<{value: string, text: string}> = [
  { value: '0', text: '注文書の一覧' },
  { value: '1', text: '顧客・車両検索' },
];

/**
 * 伝票種別名の配列情報(整備/鈑金)
 */
export const SfSlipTitleName = {
  /** 見積り */
  FirstName: '見積り',
  /** 作業指示 */
  SecondName: '作業指示',
  /** 納品書 */
  ThirdName: '納品書',
};

/**
 * 伝票種別名の配列情報(車販)
 */
export const CarSalesSlipTitleName = {
  /** 見積り */
  FirstName: '見積り',
  /** 注文書 */
  SecondName: '注文書',
};

/**
 * 画面動作設定で使用される伝票タイプの識別子
 */
export enum SlipType {
  /** 画面表示用の第一伝票種別 */
  First = 'EstimatesName',
  /** 画面表示用の第二伝票種別 */
  Second = 'InstructionsName',
  /** 画面表示用の第三伝票種別 */
  Third = 'SalesName ',
}

/**
 * ベースとなる業務メニュー(整備) 画面動作設定
 */
export const SfBaseScreenActionSetting: ISfBizMenuPageScreenActionSetting = {
  firstSlipNavigationDiv: SfEstimatesSlipDiv.SfSalesSlipSearch,
  secondSlipNavigationDiv: SfInstructionsSlipDiv.SfSalesSlipSearch,
  thirdSlipNavigationDiv: SfSalesSlipDiv.SfSalesSlipSearch,
};

/**
 * ベースとなる業務メニュー(鈑金) 画面動作設定
 */
export const RepairBaseScreenActionSetting: IRepairBizMenuPageScreenActionSetting = {
  firstSlipNavigationDiv: RepairEstimatesSlipDiv.RepairSalesSlipSearch,
  secondSlipNavigationDiv: RepairInstructionsSlipDiv.RepairSalesSlipSearch,
  thirdSlipNavigationDiv: RepairSalesSlipDiv.RepairSalesSlipSearch,
};

/**
 * ベースとなる業務メニュー(車販) 画面動作設定
 */
export const CarSalesBaseScreenActionSetting: ICarsalesBizMenuPageScreenActionSetting = {
  firstSlipNavigationDiv: CarSalesEstimatesSlipDiv.CarSalesSlipSearch,
  secondSlipNavigationDiv: CarSalesSlipOrderDiv.CarSalesSlipSearch,
};

/**
 * ベースとなる受付起動時の画面動作設定
 */
export const ReceptionBaseScreenActionSetting: IReceptionBizMenuPageScreenActionSetting = {
  sf: ReceptionNavigationDiv.CustomerVehicleSearch,
  repair: ReceptionNavigationDiv.CustomerVehicleSearch,
};

/**
 * ベースとなる業務メニュー(整備)(鈑金)(車販) 画面動作設定
 */
export const BaseScreenActionSetting: IBizMenuPageScreenActionSetting = {
  sf: SfBaseScreenActionSetting,
  repair: RepairBaseScreenActionSetting,
  carSales: CarSalesBaseScreenActionSetting,
  // 既存のプロダクト別オブジェクトを shallow merge で欠落させないため、受付は独立したトップレベルで保持する。
  reception: ReceptionBaseScreenActionSetting,
};

/**
 * 画面ID (業務メニュー(整備)(鈑金)(車販) 画面)
 */
export const MacMenuCommonPageId = 'G-Common-0000';

/**
 * 設定パスの接頭辞
 */
export const SETTING_PATH = {
  SF: 'sf',
  REPAIR: 'repair',
  CAR_SALES: 'carSales',
};

/**
 * 各プロダクトコードに対応する名称
 */
export const PRODUCT_NAME = {
  /** 整備 */
  SUPERFRONTMAN: '整備',
  /** 鈑金 */
  REPAIR: '鈑金',
  /** 車販 */
  CARSALES: '車販',
};



// WEBPACK FOOTER //
// ./src/app/feature/biz-menu-page-screen-action-setting-modal/biz-menu-page-screen-action-setting-modal.define.ts